import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/tx.jpg'
import _imports_1 from '@/assets/img/new/collect_active_icon.png'
import _imports_2 from '@/assets/img/new/down_active_icon.png'
import _imports_3 from '@/assets/img/new/down_icon.png'
import _imports_4 from '@/assets/img/new/null_icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-118cd192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_page" }
const _hoisted_2 = { class: "user_box" }
const _hoisted_3 = { class: "user_info" }
const _hoisted_4 = { class: "info_name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_ava" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fenpei" }, null, -1))
const _hoisted_7 = { class: "other_info" }
const _hoisted_8 = { class: "other_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名:", -1))
const _hoisted_10 = { class: "other_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电话:", -1))
const _hoisted_12 = { class: "other_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "学校:", -1))
const _hoisted_14 = { class: "home_box" }
const _hoisted_15 = { class: "collect_box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seachTop" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 我的收藏 ")
], -1))
const _hoisted_17 = { class: "collect_scroll" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "collect_right" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_26 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载", -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "null_box"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  class: "pagin_box"
}
const _hoisted_34 = { class: "pagin_tiao" }

import { onMounted, reactive } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import { GetCollectList, GetRemoveCollect } from '@/hooks/collectInter' // 混入收藏接口
import { useStore } from 'vuex';
import { ElMessageBox } from 'element-plus';
import getFileTypeImg from '@/hooks/use_type_imgs'
import { fileHandle } from '@/hooks/file_preview_download'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { onPreview, addExtension, downLoad, previewPic } = fileHandle()
const store = useStore()
const router = useRouter();
const person: any = reactive ({
    userInfo: {},
    //收藏列表：
    data: {
      list: [],
      PageIndex: 1,
      PageSize: 5,
      total:0
    }
})

onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg', true)
    }
    // 获取当前用户信息
    person.userInfo = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo"))));
    // 获取收藏列表
    GetCollectList(person.data)
})
//查看图片
const previewPicClick = (row: any, index: number) => {
    if (row.DownState && row.Type === 4) {
        person.data.list[index].isPic = !person.data.list[index].isPic
    }
}
//下载图片
const dowmClick = (item: any, index: number) => {
    if (!item.DownState) {
        return
    }
    downLoad(item)
}

//取消收藏提示
const cancelCollect = (item: any, index: number, PageIndex:number) => {
    ElMessageBox.confirm('是否确定取消收藏?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
        // 取消收藏
        GetRemoveCollect(item, item.Id, item.ObjType)
        person.data.PageIndex = PageIndex
        // 获取收藏列表
        setTimeout(()=>{
            GetCollectList(person.data)
        },200)
    })
}

// 分页
const currentChange = (val: number) => {
    person.data.PageIndex = val
    GetCollectList(person.data)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(person.userInfo.Account), 1),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(person.userInfo.Name), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(_toDisplayString(person.userInfo.Mobile), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(_toDisplayString(person.userInfo.SchoolName), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (person.data.list&&person.data.list.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.data.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "collect_item",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "video_img",
                      onClick: ($event: any) => (_unref(onPreview)(item,index))
                    }, [
                      (item.Type !== 4)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(getFileTypeImg)(item.Extension),
                            alt: ""
                          }, null, 8, _hoisted_20))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: ($event: any) => (previewPicClick(item,index))
                          }, [
                            _createVNode(_component_el_image, {
                              src: item.Url,
                              "preview-src-list": [item.Url],
                              "initial-index": 4,
                              fit: "cover",
                              ref_for: true,
                              ref_key: "previewPic",
                              ref: previewPic
                            }, null, 8, ["src", "preview-src-list"])
                          ], 8, _hoisted_21)),
                      _createElementVNode("span", {
                        class: _normalizeClass({Color:item.Type === 4})
                      }, _toDisplayString(_unref(addExtension)(item)), 3),
                      (item.ObjType===3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString((item.Size/1024).toFixed(2)) + "M", 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_19),
                    _createElementVNode("div", _hoisted_23, [
                      (item.ObjType===3)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "right_item",
                            onClick: ($event: any) => (dowmClick(item,index))
                          }, [
                            (item.DownState)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                              : (_openBlock(), _createElementBlock("img", _hoisted_26)),
                            _hoisted_27
                          ], 8, _hoisted_24))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "collect_item1",
                        onClick: ($event: any) => (cancelCollect(item,index,person.data.PageIndex))
                      }, "取消收藏", 8, _hoisted_28)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32)),
          (person.data.total > person.data.PageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next, jumper",
                  "current-page": person.data.PageIndex,
                  "page-size": person.data.PageSize,
                  total: person.data.total,
                  onCurrentChange: currentChange
                }, null, 8, ["current-page", "page-size", "total"]),
                _createElementVNode("div", _hoisted_34, "每页 " + _toDisplayString(person.data.PageSize) + " 条，共 " + _toDisplayString(person.data.total) + " 条", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})